import { Switch } from "antd";
import styled from "styled-components";

export const StyledSwitch = styled(Switch)`
  background-color: #c9cdd4;
  &:hover {
    background-color: #c9cdd4 !important;
  }
  &.ant-switch-checked {
    background-color: var(--main-color) !important;
  }
  &:focus {
    box-shadow: none;
  }
}
`;
